import React, { useEffect, useMemo, useState } from 'react'
import { Button, TextField, FormControl, FormControlLabel, RadioGroup, Radio, Backdrop, Box } from '@mui/material'
import BoltOutlinedIcon from '@mui/icons-material/BoltOutlined'
import CalendarMonthOutlinedIcon from '@mui/icons-material/CalendarMonthOutlined'
import PictureAsPdfOutlinedIcon from '@mui/icons-material/PictureAsPdfOutlined'
import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined'
import AppLoader from '../../../components/AppLoader/AppLoader';
import { useFormik } from 'formik'
import * as Yup from 'yup';
import jsPDF from 'jspdf'
import 'jspdf-autotable'
import LoadScheddingBlock from '../../../components/loadsheddingblock/loadscheddingblock'
import './LoadManagement.scss'
import Error from '../../../components/error/error';
import { convertDatewithTime, dBillAPI, getLogo, openJsPdfInNewTab } from '../../../services/Functions';
import { useSelector } from 'react-redux';
import { resolveDiscoCompanyCodeForBranding } from '../../../utils/adminCompany';
import {
  buildCustomerIdYupRule,
} from '../../../utils/customerIdValidation';
import { cpBaseUrl } from '../../../network/urls';
import eOpsLogo from '../../../images/eops.png';

const HOUR_NUMBERS = Array.from({ length: 24 }, (_, i) => String(i + 1).padStart(2, '0'));

const statusTone = (status) => {
    const value = String(status || '').trim().toUpperCase();
    if (!value || value === '-') return 'neutral';
    if (value === 'ON' || value === 'LIVE' || value === 'TRUE') return 'on';
    if (value === 'OFF' || value.includes('SHED') || value === 'FALSE') return 'off';
    return 'neutral';
};

const displayValue = (value) => {
    if (value === undefined || value === null || String(value).trim() === '') return '-';
    return String(value);
};

const formatScheduleDate = (value) => {
    if (!value) return '-';
    const raw = String(value).trim();
    const match = raw.match(/^(\d{1,2})-(\d{1,2})-(\d{4})$/);
    if (!match) return raw;
    const [, dd, mm, yyyy] = match;
    const date = new Date(Number(yyyy), Number(mm) - 1, Number(dd));
    if (Number.isNaN(date.getTime())) return raw;
    return date.toLocaleDateString('en-GB', {
        weekday: 'short',
        day: '2-digit',
        month: 'short',
        year: 'numeric',
    });
};

const getHourLightStatus = (data, index) => {
    if (!data) return -1;
    if (Array.isArray(data.planned_sch) && data.planned_sch[index] !== undefined) {
        return data.planned_sch[index];
    }
    const hour = index + 1;
    const key = hour <= 12
        ? `AM_PLANNED${String(hour).padStart(2, '0')}`
        : `PM_PLANNED${String(hour).padStart(2, '0')}`;
    const label = String(data[key] || '').toUpperCase();
    if (label === 'ON') return 0;
    if (label === 'OFF') return 1;
    return -1;
};

const COMPANY_NAMES = {
    '10': 'Power Information Technology Company',
    '11': 'Lahore Electric Supply Company',
    '12': 'Gujranwala Electric Power Company',
    '13': 'Faisalabad Electric Supply Company',
    '14': 'Islamabad Electric Supply Company',
    '15': 'Multan Electric Power Company',
    '26': 'Peshawar Electric Supply Company',
    '27': 'Hazara Electric Supply Company',
    '37': 'Hyderabad Electric Supply Company',
    '38': 'Sukkur Electric Power Company',
    '48': 'Quetta Electric Supply Company',
    '59': 'Tribal Electric Supply Company',
};

const getCompanyName = (code) => COMPANY_NAMES[String(code)] || 'Electric Supply Company';

const padHour = (value) => String(value).padStart(2, '0');

const statusLabelForHour = (status) => {
    if (status === 0) return 'Power On';
    if (status === 1) return 'Load Shedding';
    return 'No Data';
};

const statusShortLabel = (status) => {
    if (status === 0) return 'ON';
    if (status === 1) return 'OFF';
    return '-';
};

const LoadManagement = () => {

    const initialValues = {
        iv_reference_number: '',
        iv_consumer_id: ''
    }

    const [viewBackdrop, setViewBackdrop] = useState(false);
    const [error, setError] = useState('')
    const [searchBy, setSearchBy] = useState('consumerId');
    const {
        token,
        code: userCode,
        roleId,
        selectedAdminCompanyCode,
        name: userName,
        roleName,
    } = useSelector((state) => state.auth);
    const userCompany = resolveDiscoCompanyCodeForBranding(
        userCode,
        roleId,
        selectedAdminCompanyCode,
    );
    const [loadScheddingData, setLoadScheddingData] = useState()
    const [exportingPdf, setExportingPdf] = useState(false);

    const SearchBy = (event) => {
        values.iv_search_by = event.target.value;
        setSearchBy(event.target.value);
        values.iv_consumer_id = ''
        values.iv_reference_number = ''
        setLoadScheddingData()
    };

    const { values, errors, touched, handleBlur, handleChange, handleSubmit } = useFormik({
        initialValues,
        validationSchema: Yup.object({
            iv_reference_number: Yup.string().when('iv_search_by', {
                is: () => searchBy === 'referenceNo',
                then: Yup.string().min(14, 'Reference No. must be 14 digits.').max(14, 'Reference No. must be 14 digits.').required("Enter reference number."),
                otherwise: Yup.string().optional()
            }),
            iv_consumer_id: Yup.string().when('iv_search_by', {
                is: () => searchBy === 'consumerId',
                then: buildCustomerIdYupRule(userCompany),
                otherwise: Yup.string().optional()
            }),
        }),
        onSubmit: async (values) => {
            if (searchBy === 'referenceNo') {
                setViewBackdrop(true)
                let requestOptions = {
                    method: 'GET',
                    redirect: 'follow',
                };

                await fetch(cpBaseUrl + "?refno=" + values.iv_reference_number, requestOptions)
                    .then(response => response.json())
                    .then(result => {
                        if (result.tblStatus[0].status === true) {
                            let feederCode = result.Table[0].FEEDERCD
                            let myHeaders = new Headers();
                            myHeaders.append("Cookie", "ccms_session=eyJpdiI6IndJaUpBUDduQVUybVJwTWJ2WCtERkE9PSIsInZhbHVlIjoiNGhlaXRWdlY2cWh0bnFiUldRcklqb1lPWExZQ3BjZ2t1dlpPOGduQUs1ZzhOeTcyejZXU0U3ekpaVXNKSVZ2aiIsIm1hYyI6IjM3NThlMjJhNjk2NWQ0NjdiY2ZiM2NlY2FkN2FkNmM0OWY5ODkzYjAwZDA5ZmMzZWFkZDNhOGQzZmVlM2Q5MjgifQ%3D%3D");
                            let requestOptions = {
                                method: 'GET',
                                headers: myHeaders,
                                redirect: 'follow',
                            };

                            fetch("https://ccms.pitc.com.pk/api/search_feeder_schedule?feeder_code=" + feederCode + "&disco_code=" + values.iv_reference_number.slice(2, 4) + "000", requestOptions)
                                .then(response => response.json())
                                .then(result => {
                                    setLoadScheddingData(result.server_response[0])
                                    setViewBackdrop(false)
                                })
                                .catch(() => {});
                        }
                        else {
                            setError('Reference number not exists!')
                            setViewBackdrop(false)
                        }
                    })
                    .catch(() => {});
            }
            else if (searchBy === 'consumerId') {
                setViewBackdrop(true)
                let apiResponse = await dBillAPI(token, values.iv_consumer_id)
                if (apiResponse.status) {
                    let referenceNo = apiResponse.basicInfo.refNo.replace(/ /g, "").slice(0, 14)
                    let requestOptions = {
                        method: 'GET',
                        redirect: 'follow',
                    };

                    await fetch(cpBaseUrl + "?refno=" + referenceNo, requestOptions)
                        .then(response => response.json())
                        .then(result => {
                            if (result.tblStatus[0].status === true) {
                                let feederCode = result.Table[0].FEEDERCD
                                let myHeaders = new Headers();
                                myHeaders.append("Cookie", "ccms_session=eyJpdiI6IndJaUpBUDduQVUybVJwTWJ2WCtERkE9PSIsInZhbHVlIjoiNGhlaXRWdlY2cWh0bnFiUldRcklqb1lPWExZQ3BjZ2t1dlpPOGduQUs1ZzhOeTcyejZXU0U3ekpaVXNKSVZ2aiIsIm1hYyI6IjM3NThlMjJhNjk2NWQ0NjdiY2ZiM2NlY2FkN2FkNmM0OWY5ODkzYjAwZDA5ZmMzZWFkZDNhOGQzZmVlM2Q5MjgifQ%3D%3D");
                                let requestOptions = {
                                    method: 'GET',
                                    headers: myHeaders,
                                    redirect: 'follow',
                                };

                                fetch("https://ccms.pitc.com.pk/api/search_feeder_schedule?feeder_code=" + feederCode + "&disco_code=" + referenceNo.slice(2, 4) + "000", requestOptions)
                                    .then(response => response.json())
                                    .then(result => {
                                        setLoadScheddingData(result.server_response[0])
                                        setViewBackdrop(false)
                                    })
                                    .catch(() => {});
                            }
                            else {
                                setError('Customer ID. does not exists!')
                                setViewBackdrop(false)
                            }
                        })
                        .catch(() => {});
                } else {
                    setError('Customer ID. not found!')
                    setViewBackdrop(false)
                }
            }
        }
    })

    useEffect(() => {
        if (values.iv_reference_number.length < 14) {
            setLoadScheddingData()
        }
    }, [values.iv_reference_number])

    const currentHourIndex = useMemo(() => new Date().getHours(), []);

    const handleKeyPress = (event) => {
        if (event.key === 'Enter') {
            event.preventDefault();
            handleSubmit();
        }
    };

    const errorCloses = () => {
        setError('')
    }

    const feederStatus = loadScheddingData ? loadScheddingData.Feeder_Status : '-';
    const feederTone = statusTone(feederStatus);
    const scheduleDateLabel = formatScheduleDate(loadScheddingData?.Today);

    const infoItems = [
        { label: 'Date', value: scheduleDateLabel },
        { label: 'Feeder', value: displayValue(loadScheddingData?.Feeder) },
        { label: 'Grid', value: displayValue(loadScheddingData?.Grid) },
        { label: 'Category', value: displayValue(loadScheddingData?.Feeder_Category) },
        { label: 'Loss', value: displayValue(loadScheddingData?.Percentage_Loss) },
        { label: 'Status', value: displayValue(feederStatus), tone: feederTone, isStatus: true },
    ];

    const handleExportPdf = () => {
        if (!loadScheddingData || exportingPdf) return;

        setExportingPdf(true);
        try {
            const companyCode = String(userCompany || userCode || '');
            const pdf = new jsPDF('portrait', 'mm', 'a4', { compressPdf: true });
            const pageWidth = pdf.internal.pageSize.getWidth();
            const pageHeight = pdf.internal.pageSize.getHeight();
            const marginX = 14;
            const tallLogoCodes = ['11', '12', '13', '16', '27', '48', '59'];
            const isTallLogo = tallLogoCodes.includes(companyCode);
            const logoWidth = isTallLogo ? 22 : 28;
            const logoHeight = isTallLogo ? 18 : 9;

            try {
                pdf.addImage(getLogo(companyCode), 'PNG', marginX, 8, logoWidth, logoHeight);
                pdf.addImage(
                    eOpsLogo,
                    'PNG',
                    isTallLogo ? marginX + 24 : marginX + 1,
                    isTallLogo ? 14 : 19,
                    18,
                    7,
                );
            } catch (_) {
                // Logos are optional; continue with text header.
            }

            pdf.setFontSize(9);
            pdf.setTextColor(30, 41, 59);
            pdf.text(convertDatewithTime(new Date()), pageWidth - 14, 12, { align: 'right' });
            pdf.text(`Name: ${userName || '-'}`, pageWidth - 14, 17, { align: 'right' });
            pdf.text(`Designation: ${roleName || '-'}`, pageWidth - 14, 22, { align: 'right' });

            pdf.setFontSize(12);
            pdf.setTextColor(9, 102, 157);
            pdf.text(getCompanyName(companyCode), pageWidth / 2, 12, { align: 'center' });
            pdf.setFontSize(11);
            pdf.setTextColor(15, 23, 42);
            pdf.text('Load Shedding Schedule', pageWidth / 2, 18, { align: 'center' });
            pdf.setFontSize(9);
            pdf.setTextColor(71, 85, 105);
            pdf.text(
                `24-hour feeder plan · ${scheduleDateLabel}`,
                pageWidth / 2,
                24,
                { align: 'center' },
            );

            const infoBody = [[
                scheduleDateLabel,
                displayValue(loadScheddingData?.Feeder),
                displayValue(loadScheddingData?.Grid),
                displayValue(loadScheddingData?.Feeder_Category),
                displayValue(loadScheddingData?.Percentage_Loss),
                displayValue(feederStatus),
            ]];

            pdf.autoTable({
                startY: 28,
                head: [['Date', 'Feeder', 'Grid', 'Category', 'Loss', 'Status']],
                body: infoBody,
                theme: 'grid',
                styles: {
                    fontSize: 8,
                    cellPadding: 2,
                    halign: 'center',
                    valign: 'middle',
                    textColor: [30, 41, 59],
                    lineColor: [226, 232, 240],
                    lineWidth: 0.2,
                },
                headStyles: {
                    fillColor: [9, 102, 157],
                    textColor: [255, 255, 255],
                    fontStyle: 'bold',
                    fontSize: 8,
                },
                bodyStyles: {
                    fillColor: [248, 250, 252],
                },
                margin: { left: marginX, right: marginX },
            });

            const scheduleRows = HOUR_NUMBERS.map((_, index) => {
                const status = getHourLightStatus(loadScheddingData, index);
                const short = statusShortLabel(status);
                const startHour = index;
                const endHour = index + 1;
                return [
                    String(index + 1),
                    `${padHour(startHour)}:00 – ${padHour(endHour)}:00`,
                    short,
                    short,
                    short,
                    short,
                    statusLabelForHour(status),
                    status,
                    index === currentHourIndex,
                ];
            });

            pdf.autoTable({
                startY: (pdf.lastAutoTable?.finalY || 42) + 6,
                head: [[
                    'Sr',
                    'Time Slot',
                    '00',
                    '15',
                    '30',
                    '45',
                    'Status',
                ]],
                body: scheduleRows.map((row) => row.slice(0, 7)),
                theme: 'grid',
                styles: {
                    fontSize: 8,
                    cellPadding: 1.8,
                    halign: 'center',
                    valign: 'middle',
                    textColor: [30, 41, 59],
                    lineColor: [226, 232, 240],
                    lineWidth: 0.2,
                },
                headStyles: {
                    fillColor: [15, 23, 42],
                    textColor: [255, 255, 255],
                    fontStyle: 'bold',
                    fontSize: 8,
                },
                alternateRowStyles: {
                    fillColor: [248, 250, 252],
                },
                columnStyles: {
                    0: { cellWidth: 12 },
                    1: { cellWidth: 38, halign: 'left' },
                    2: { cellWidth: 18 },
                    3: { cellWidth: 18 },
                    4: { cellWidth: 18 },
                    5: { cellWidth: 18 },
                    6: { cellWidth: 'auto', fontStyle: 'bold' },
                },
                margin: { left: marginX, right: marginX, bottom: 14 },
                didParseCell: (data) => {
                    if (data.section !== 'body') return;

                    const meta = scheduleRows[data.row.index];
                    if (!meta) return;
                    const status = meta[7];
                    const isCurrent = meta[8];

                    if (data.column.index >= 2 && data.column.index <= 5) {
                        if (status === 0) {
                            data.cell.styles.fillColor = [253, 230, 138];
                            data.cell.styles.textColor = [146, 64, 14];
                        } else if (status === 1) {
                            data.cell.styles.fillColor = [254, 202, 202];
                            data.cell.styles.textColor = [153, 27, 27];
                        } else {
                            data.cell.styles.fillColor = [226, 232, 240];
                            data.cell.styles.textColor = [71, 85, 105];
                        }
                    }

                    if (data.column.index === 6) {
                        if (status === 0) {
                            data.cell.styles.fillColor = [254, 243, 199];
                            data.cell.styles.textColor = [146, 64, 14];
                        } else if (status === 1) {
                            data.cell.styles.fillColor = [254, 226, 226];
                            data.cell.styles.textColor = [153, 27, 27];
                        } else {
                            data.cell.styles.fillColor = [241, 245, 249];
                            data.cell.styles.textColor = [71, 85, 105];
                        }
                    }

                    if (isCurrent) {
                        data.cell.styles.fontStyle = 'bold';
                        if (data.column.index === 1) {
                            data.cell.text = [`${meta[1]} (Now)`];
                        }
                    }
                },
            });

            const totalPages = pdf.internal.getNumberOfPages();
            for (let i = 1; i <= totalPages; i += 1) {
                pdf.setPage(i);
                pdf.setFontSize(8);
                pdf.setTextColor(148, 163, 184);
                pdf.text(`Page ${i} of ${totalPages}`, pageWidth - 14, pageHeight - 8, {
                    align: 'right',
                });
            }

            const feederSlug = String(loadScheddingData?.Feeder || 'feeder')
                .replace(/[^\w.-]+/g, '-')
                .replace(/-+/g, '-')
                .replace(/^-|-$/g, '');
            const dateSlug = String(loadScheddingData?.Today || 'schedule').replace(/[^\w.-]+/g, '-');
            openJsPdfInNewTab(
                pdf,
                `Load-Shedding-Schedule-${feederSlug}-${dateSlug}.pdf`,
            );
        } finally {
            setExportingPdf(false);
        }
    };

    return (
        <>
            <Box className="form-box load-shedding-form-box">
            <div className="load-shedding-page">
                <div className="load-shedding-page__hero">
                    <div className="load-shedding-page__hero-icon" aria-hidden="true">
                        <BoltOutlinedIcon />
                    </div>
                    <div className="load-shedding-page__hero-copy">
                        <h1>Load Shedding Schedule</h1>
                        <p>24-hour feeder plan with clock times in 15-minute slots</p>
                    </div>
                    {loadScheddingData?.Today && (
                        <div className="load-shedding-page__hero-date">
                            <CalendarMonthOutlinedIcon fontSize="small" />
                            <span>{scheduleDateLabel}</span>
                        </div>
                    )}
                </div>

                <div className="load-shedding-page__body">
                    <form className="load-shedding-connection-card" onSubmit={handleSubmit}>
                            <div className="load-shedding-section-title">
                                <span className="load-shedding-section-title__bar" aria-hidden="true" />
                                Connection Details
                            </div>

                            <div className="load-shedding-search">
                                <div className="load-shedding-search__field">
                                    <span className="load-shedding-search__label">Search By</span>
                                    <FormControl>
                                        <RadioGroup
                                            className="load-shedding-search__radios"
                                            row
                                            name="iv_search_by"
                                            value={searchBy}
                                            onChange={SearchBy}
                                        >
                                            <FormControlLabel
                                                value="consumerId"
                                                control={<Radio size="small" />}
                                                label="Customer ID."
                                            />
                                            <FormControlLabel
                                                value="referenceNo"
                                                control={<Radio size="small" />}
                                                label="Reference No."
                                            />
                                        </RadioGroup>
                                    </FormControl>
                                </div>

                                {searchBy === 'consumerId' && (
                                    <div className="load-shedding-search__field load-shedding-search__field--grow">
                                        <span className="load-shedding-search__label">Customer ID.</span>
                                        <TextField
                                            className="load-shedding-search__input"
                                            inputProps={{ maxLength: 10 }}
                                            size="small"
                                            type="text"
                                            autoComplete="off"
                                            name="iv_consumer_id"
                                            value={values.iv_consumer_id}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            onKeyPress={handleKeyPress}
                                            id="iv_consumer_id"
                                            placeholder="Enter customer ID"
                                        />
                                        {errors.iv_consumer_id && touched.iv_consumer_id && (
                                            <span className="load-shedding-search__error">{errors.iv_consumer_id}</span>
                                        )}
                                    </div>
                                )}

                                {searchBy === 'referenceNo' && (
                                    <div className="load-shedding-search__field load-shedding-search__field--grow">
                                        <span className="load-shedding-search__label">Reference No.</span>
                                        <TextField
                                            className="load-shedding-search__input"
                                            inputProps={{ maxLength: 14 }}
                                            size="small"
                                            type="text"
                                            autoComplete="off"
                                            name="iv_reference_number"
                                            value={values.iv_reference_number}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            onKeyPress={handleKeyPress}
                                            id="iv_reference_number"
                                            placeholder="14-digit reference number"
                                        />
                                        {errors.iv_reference_number && touched.iv_reference_number && (
                                            <span className="load-shedding-search__error">{errors.iv_reference_number}</span>
                                        )}
                                    </div>
                                )}

                                <Button
                                    className="load-shedding-search__submit"
                                    variant="contained"
                                    type="submit"
                                    startIcon={<SearchOutlinedIcon />}
                                >
                                    Search
                                </Button>
                            </div>

                            <div className="load-shedding-info-bar">
                                {infoItems.map((item) => (
                                    <div className="load-shedding-info-bar__item" key={item.label}>
                                        <span className="load-shedding-info-bar__label">{item.label}</span>
                                        {item.isStatus ? (
                                            <span className={`load-shedding-info-bar__status load-shedding-info-bar__status--${item.tone}`}>
                                                {item.value}
                                            </span>
                                        ) : (
                                            <span className="load-shedding-info-bar__value">{item.value}</span>
                                        )}
                                    </div>
                                ))}
                            </div>
                        </form>

                        {error && (
                            <Error
                                error={error}
                                onClose={() => errorCloses()}
                                backgroundColor="#FFC0CB"
                                textColor="#bb0303"
                                iconColor="#bb0303"
                            />
                        )}

                        <section className="load-shedding-schedule-panel">
                            <div className="load-shedding-toolbar">
                                <div className="load-shedding-toolbar__meta">
                                    <div className="load-shedding-toolbar__title">24-Hour Schedule</div>
                                    <div className="load-shedding-toolbar__subtitle">
                                        {loadScheddingData?.Today
                                            ? `Plan dated ${scheduleDateLabel} · slots every 15 minutes`
                                            : 'Search a connection to load today\'s feeder plan'}
                                    </div>
                                </div>
                                <div className="load-shedding-toolbar__actions">
                                    <div className="load-shedding-legend">
                                        <div className="load-shedding-legend__item">
                                            <span className="load-shedding-legend__swatch load-shedding-legend__swatch--on" />
                                            <span>Power On</span>
                                        </div>
                                        <div className="load-shedding-legend__item">
                                            <span className="load-shedding-legend__swatch load-shedding-legend__swatch--off" />
                                            <span>Load Shedding</span>
                                        </div>
                                        <div className="load-shedding-legend__item">
                                            <span className="load-shedding-legend__swatch load-shedding-legend__swatch--unknown" />
                                            <span>No Data</span>
                                        </div>
                                    </div>
                                    <Button
                                        className="load-shedding-export-btn"
                                        variant="outlined"
                                        size="small"
                                        startIcon={<PictureAsPdfOutlinedIcon />}
                                        onClick={handleExportPdf}
                                        disabled={!loadScheddingData || exportingPdf}
                                    >
                                        {exportingPdf ? 'Exporting…' : 'Export PDF'}
                                    </Button>
                                </div>
                            </div>

                            <div className="load-shedding-grid">
                                {HOUR_NUMBERS.map((hour, index) => (
                                    <LoadScheddingBlock
                                        key={hour}
                                        number={hour}
                                        lightStatus={getHourLightStatus(loadScheddingData, index)}
                                        isCurrent={Boolean(loadScheddingData) && index === currentHourIndex}
                                    />
                                ))}
                            </div>
                        </section>
                </div>
            </div>
            </Box>

            <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1000 }}
                open={viewBackdrop}
            >
                <AppLoader />
            </Backdrop>
        </>
    )
}

export default LoadManagement
